import { eventDetailModal as eventDetailModalDiagram} from '@process-advisor/process-miner/processMiner/processMiner';

export type EventDetailProps = {
    param?: string,
};

export const eventDetail = ({ param}: EventDetailProps) => {
    eventDetailModalDiagram();
};


